
//Normally this should be in .env file
const GoogleMapsApiKey: string = String(process.env.REACT_APP_GOOGLE_MAPPS_API_KEY);
export default GoogleMapsApiKey;
